import 'vuetify/styles'
import { createVuetify, type VuetifyOptions } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { aliases, mdi } from 'vuetify/iconsets/mdi'
import '@mdi/font/css/materialdesignicons.css'

export interface CreateAppVuetifyOptions {
  /** Element used as teleport target for overlays (keeps them inside Shadow DOM). */
  attach?: Element | string
}

export function createAppVuetify(options: CreateAppVuetifyOptions = {}) {
  const attach = options.attach

  const vuetifyOptions: VuetifyOptions = {
    components,
    directives,
    icons: {
      defaultSet: 'mdi',
      aliases,
      sets: {
        mdi,
      },
    },
  }

  if (attach) {
    vuetifyOptions.defaults = {
      VOverlay: {
        attach,
      },
      VMenu: {
        attach,
      },
      VDialog: {
        attach,
      },
      VSnackbar: {
        attach,
      },
      VTooltip: {
        attach,
      },
      VSelect: {
        menuProps: { attach },
      },
      VAutocomplete: {
        menuProps: { attach },
      },
      VCombobox: {
        menuProps: { attach },
      },
    }
  }

  return createVuetify(vuetifyOptions)
}
